import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentDefinition } from '../../models/agent.models';

@Component({
  selector: 'app-agent-directory',
  templateUrl: './agent-directory.component.html',
  styleUrls: ['./agent-directory.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentDirectoryComponent {
  @Input() agents: AgentDefinition[] = [];
  @Output() readonly startChat = new EventEmitter<string>();

  trackByCode(_: number, agent: AgentDefinition): string { return agent.code; }
}
